import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Hook aislado para obtener estadísticas del documento (revisión + usuarios únicos).
 * Usado por la marquesina rotativa del visor.
 *
 * Filosofía: NO modifica nada del visor. Solo fetcha datos.
 * Si falla, devuelve null y la marquesina muestra el Ref: tradicional.
 */
export const useDocumentStats = (manualId, enabled = true) => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!enabled || !manualId) {
      setStats(null);
      return;
    }
    let cancelled = false;

    const fetchStats = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/mis-documentos/stats/${manualId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) setStats(res.data);
      } catch (err) {
        // Silencioso — no es crítico. La marquesina cae al modo Ref:
        if (!cancelled) setStats(null);
      }
    };

    fetchStats();
    return () => {
      cancelled = true;
    };
  }, [manualId, enabled]);

  return stats;
};

export default useDocumentStats;
